const productRouter = {
    route: null,
    name: null,
    title: '产品管理',
    type: 'folder', // 类型: folder, tab, view
    icon: 'iconfont icon-erjituandui',
    filePath: 'view/news/', // 文件路径
    order: null,
    inNav: true,
    children: [
      {
        title: '产品列表',
        type: 'view',
        name: 'ProductList',
        route: '/product/list',
        filePath: 'view/products/product/product-list.vue',
        inNav: true,
        icon: 'iconfont icon-fold',
      },
      {
        title: '产品分类',
        type: 'view',
        name: 'ProductCategoryList',
        route: '/product/category/list',
        filePath: 'view/products/category/category-tree.vue',
        inNav: true,
        icon: 'iconfont icon-tushuguanli',
      }      
    ],
  }
  
  export default productRouter
  